var MainMap = (function(){
  'use strict';

  var mapGL = null;
  var container = document.getElementById('main-map');
  var searchMode = true;
  var layers = [];

  var getLayerByName = function(name) {
    let layer = null;

    layers.forEach(function(item){
      if (item.getName() === name) {
        layer = item;
      }
    });

    return layer;
  };

  var init = function() {
    if (!maplibregl.supported()) {
      $(container).find('.maplibregl-unsupported').removeClass('is-hidden');
    } else {

      let zoom = 11;
      let minZoom = 9;
      let center =  [4.86, 45.76];
      let style = "/typo3conf/ext/gl_portailvelo_template/Resources/Public/MapLibreStyles/vector.json";
      let controls = {};

      if (window.matchMedia("(max-width: 767px)").matches) {
        controls = {
          navigation: {enable: 1, position: 'top-left'},
          geolocate: {enable: 0, position: 'top-left'},
        };
      } else {
        controls = {
          navigation: {enable: 1, position: 'bottom-right'},
          geolocate: {enable: 0, position: 'bottom-right'},
        };
      }

      mapGL = new MapGL(container, zoom, minZoom, center, style, controls);
      var mapObject = mapGL.getMapObject();

      mapObject.on('load', function() {

        let cyclewayLayer = new CyclewayLayer(mapGL, true);
        // Hide voies lyonnaises
        //let voieLyonnaiseLayer = new VoieLyonnaiseLayer(mapGL);
        let bikeRackLayer = new BikeRackLayer(mapGL);
        let bikeParkingLayer = new BikeParkingLayer(mapGL);
        let velovStationLayer = new VelovStationLayer(mapGL);
        let bikePumpLayer = new BikePumpLayer(mapGL);
        let publicToiletLayer = new PublicToiletLayer(mapGL);
        let waterFountainLayer = new WaterFountainLayer(mapGL);

        layers = [
          // Hide voies lyonnaises
          //cyclewayLayer, voieLyonnaiseLayer, bikeRackLayer, bikeParkingLayer, velovStationLayer,
          cyclewayLayer, bikeRackLayer, bikeParkingLayer, velovStationLayer,
          bikePumpLayer, publicToiletLayer, waterFountainLayer
        ];

        $('#address-map-control').removeClass('is-hidden');
        $('#filters-map-control').removeClass('is-hidden');
        $('#legend-map-control').removeClass('is-hidden');

        $('#legend-map-control #js-map-show-legend').click(function () {
          $(this).toggleClass('is-active');
          if ($(this).hasClass('is-active')) {
            $(this).attr('title', 'Fermer la légende');
            $('#legend-map-control #js-map-legend-panel').removeClass('is-hidden');
          } else {
            $(this).attr('title', 'Ouvrir la légende');
            $('#legend-map-control #js-map-legend-panel').addClass('is-hidden');
          }
        });

        $('#legend-map-control #js-map-legend-close').click(function () {
          $('#legend-map-control #js-map-legend-panel').addClass('is-hidden');
          $('#legend-map-control #js-map-show-legend').removeClass('is-active');
        });

        $('#address-map-control #js-map-search').click(function () {
          searchMode = true;
        });

        $('#address-map-control #js-map-directions').click(function () {
          searchMode = false;
          JourneyPlanner.open();
        });

        $('#filters-map-control .js-map-filters-more-less').click(function () {
          var span = $(this).find('span');
          var label = span.text();
          var altLabel = span.data('altlabel');
          span.text(altLabel);
          span.data('altlabel', label);
          $(this).toggleClass('is-active');
          if ($(this).hasClass('is-active')) {
            $(this).attr('title', 'Masquer les filtres');
          } else {
            $(this).attr('title', 'Afficher les filtres');
          }
          $('#filters-map-control .js-map-filter-more').toggleClass('is-hidden');
        });

        $('#filters-map-control .js-map-filter').click(function () {
          var layerName = $(this).data('layer');
          var selectedLayer = getLayerByName(layerName);

          if (selectedLayer) {
            if ($(this).hasClass('is-active')) {
              selectedLayer.disable();
              $(this).removeClass('is-active');
            } else {
              selectedLayer.enable();
              $(this).addClass('is-active');
            }
          }
        });

        //mise à jour du aria-label du canvas
        $('.maplibregl-canvas').attr('aria-label', 'Carte des aménagements pour les vélos');

        SearchAddressControl.init(mapGL);
        GeolocationControl.init(mapGL);
        JourneyPlanner.init(mapGL);
        JourneyPlanner.initAfterLoad();
        JourneyPlannerDateTime.init();

      });
    }
  };

  return {
    init: init
  };

}());
